<template>
  <TemplateView>
    <div class="container">
      <div
        class="d-flex flex-wrap mb-8"
        v-if="
          $userCheckAccess({ checkUserType: 'superadmin' }) ||
          $userCheckAccess({ abilities: 'view_notifications' })
        "
      >
        <BaseButton
          v-for="(page, p) in list"
          :key="'button_' + p"
          :text="page.text"
          style-type="chip"
          :disabled="$route.name === page.toName || $route.name === page.toName + 'Edit'"
          @click="$router.push({ name: page.toName })"
        />
      </div>
      <router-view></router-view>
    </div>
  </TemplateView>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'settingsPushNotifications',
  data() {
    return {}
  },
  computed: {
    ...mapState(['configData']),
    list() {
      return [
        {
          toName: 'settingsPushNotificationsManual',
          text: this.localStorage.translations.pages['setting-push_notifications'].main[
            'push-manual'
          ],
        },
        {
          toName: 'settingsPushNotificationsTriggered',
          text: this.localStorage.translations.pages['setting-push_notifications'].main[
            'push-triggered'
          ],
        },
        {
          toName: 'settingsPushNotificationsProjects',
          text: this.localStorage.translations.pages['setting-push_notifications'].main[
            'push-triggered-projects'
          ],
        },
        {
          toName: 'settingsPushNotificationsHistory',
          text: this.localStorage.translations.pages['common'].text['history'],
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-wrap {
  gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    gap: 12px;
  }
}
</style>